import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

// Live ETA progress for a pending/processing withdrawal.
export function WithdrawalEta({ record, etaHours = 2 }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 30000); return () => clearInterval(t); }, []);
  if (!["pending", "processing"].includes(record.status)) return null;
  const start = new Date(record.created_at).getTime();
  const due = start + etaHours * 3600 * 1000;
  const pct = Math.max(4, Math.min(100, ((now - start) / (due - start)) * 100));
  const late = now > due;
  const remainMin = Math.max(0, Math.round((due - now) / 60000));
  const remain = late ? "Taking longer than usual — our team is on it" : remainMin >= 60 ? `~${Math.floor(remainMin / 60)}h ${remainMin % 60}m left` : `~${remainMin} min left`;
  const dueLabel = new Date(due).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  const stage = record.status === "processing" ? 2 : 1;
  return (
    <div className="mt-2 rounded-xl bg-blue-50 border border-blue-100 p-2.5" data-testid={`withdraw-eta-${record.id}`}>
      <div className="flex items-center justify-between text-[11px]">
        <span className="font-bold text-blue-800 flex items-center gap-1"><Clock className="w-3.5 h-3.5" />{late ? "Delayed" : `Expected by ${dueLabel}`}</span>
        <span className={`font-semibold ${late ? "text-amber-700" : "text-blue-700"}`} data-testid={`withdraw-eta-remain-${record.id}`}>{remain}</span>
      </div>
      <div className="mt-1.5 h-2 rounded-full bg-blue-100 overflow-hidden">
        <div className={`h-full rounded-full transition-[width] duration-700 ${late ? "bg-amber-400" : record.status === "processing" ? "bg-emerald-500" : "bg-blue-500"} ${!late ? "rl-eta-shimmer" : ""}`} style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-1.5 grid grid-cols-3 text-[9px] font-bold text-center">
        {["Requested", "Processing", "Paid"].map((l, i) => <span key={l} className={i < stage ? "text-emerald-700" : i === stage ? "text-blue-700" : "text-slate-400"}>{i < stage ? "✓ " : ""}{l}</span>)}
      </div>
    </div>
  );
}
